
function install(editor, config = {}) {

    // TODO: implement properly

    // if(config.editorButton !== undefined) {
    //     let drag = editor.view.area._drag;
    //     drag.button = config.editorButton;
    // }
}

const DragButtonPlugin = {
    name: 'drag-button',
    install,
};
export default DragButtonPlugin;